export default "__VITE_ASSET__Bc02ALqM__"